<template>
  <div class="flex w-full flex-wrap sm:flex-nowrap sm:space-x-4">
    <div class="w-full sm:w-1/2">
      <FirstNameField
        :label="$t('field.first-name.label') + labelSuffix"
        :placeholder="firstNamePlaceholder"
        v-on="$listeners"
        @result="onNameResult"
      />
    </div>

    <div class="w-full sm:w-1/2 mt-4 sm:mt-0">
      <LastNameField
        :label="$t('field.last-name.label') + labelSuffix"
        :placeholder="lastNamePlaceholder"
        v-on="$listeners"
        @result="onNameResult"
      />
    </div>
  </div>
</template>

<script>
import FirstNameField from 'chimera/all/components/form/fields/firstName/FirstNameField'
import LastNameField from 'chimera/all/components/form/fields/lastName/LastNameField'
import { EventBus } from 'chimera/all/plugins/eventbus'

export default {
  name: 'SplitNameFormPart',

  components: { FirstNameField, LastNameField },

  props: {
    labelSuffix: { type: String, default: '' },
    firstNamePlaceholder: { type: String, default: '' },
    lastNamePlaceholder: { type: String, default: '' },
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      validationState: {
        'first-name': false,
        'last-name': false,
      },
    }
  },

  computed: {
    /**
     * @returns {string}
     */
    firstName() {
      return this.$store.getters['lead/getData']('first-name', '')
    },

    /**
     * @returns {string}
     */
    lastName() {
      return this.$store.getters['lead/getData']('last-name', '')
    },

    /**
     * @returns {boolean}
     */
    allValid() {
      return Object.values(this.validationState).every(Boolean)
    },
  },

  watch: {
    firstName: 'setName',
    lastName: 'setName',

    /**
     * @param {boolean} newVal
     * @param {boolean} oldVal
     */
    allValid(newVal, oldVal) {
      if (newVal !== oldVal && this.allValid) {
        EventBus.emitFormAllNameFieldsValidEvent(
          Object.keys(this.validationState),
        )
      }
    },
  },

  /**
   */
  mounted() {
    this.setName()
  },

  methods: {
    /**
     * Handle validation result from child fields
     *
     * @param {object} param0
     * @param {string} param0.field
     * @param {boolean} param0.isValid
     */
    onNameResult({ field, isValid }) {
      if (field in this.validationState) {
        this.validationState[field] = isValid
      }
    },

    /**
     * Set the full name in the lead store
     */
    setName() {
      const first = this.firstName
      const last = this.lastName

      if (!first && !last) {
        return
      }

      const fullName = `${first} ${last}`.trim()

      if (!fullName) {
        return
      }

      this.$store.dispatch('lead/add', {
        key: 'name',
        value: fullName,
      })

      this.$store.dispatch('lead/add', {
        key: 'custom-dimension-2',
        value: `${first}|${last}`.trim(),
      })
    },
  },
}
</script>
